import { render, staticRenderFns } from "./Y67TSummary.vue?vue&type=template&id=376c6073&scoped=true&"
import script from "./Y67TSummary.vue?vue&type=script&lang=js&"
export * from "./Y67TSummary.vue?vue&type=script&lang=js&"
import style0 from "./Y67TSummary.vue?vue&type=style&index=0&id=376c6073&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376c6073",
  null
  
)

export default component.exports